var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ik-data-table',{attrs:{"entity-name":_vm.$t('pay'),"model":_vm.model,"icon":"mdi-cash-plus"}})
}
var staticRenderFns = []

export { render, staticRenderFns }